export default {"src":"/_next/static/media/expand.462ce3b2.svg","height":9,"width":16};